
const NEW_ROUTE_BASE = 'https://at-routes-for-map-d0602397f1c7.herokuapp.com';

exec();

async function exec() {

let params = new URLSearchParams(window.location.search)

let idParam = false;
if(params && params.has('id')) {
  idParam = params.get('id');
} 

console.log('Current ID param:', idParam)


if(idParam) {

  // Use the new route that handles token fetching and Aura API call
  const REQUEST_URL = `${NEW_ROUTE_BASE}/get-qr-data?idParam=${idParam}`;


    const response = await fetch(REQUEST_URL, {
        method: 'GET',
        headers: {
            'ngrok-skip-browser-warning': 'true'
        }
    });

  let apiData;

  if (!response.ok) {
    console.error('API request failed:', response.status, response.statusText);
    return;
  }

  const responseData = await response.json();
  apiData = responseData.data; // Extract data from the response wrapper
  console.log('API Response:', apiData);

  // Extract status and product ID
  const currentOnchainStatus = apiData.currentOnchainStatus;
  const productId = apiData.productId;
  console.log('Product Status:', currentOnchainStatus, 'Product ID:', productId);

  // Parse the attributes JSON string
  const attributes = JSON.parse(apiData.attributes);
  console.log('Parsed Attributes:', attributes);

  // Handle Claim Button State based on Status
  handleClaimButtonState(currentOnchainStatus, productId, idParam);

  // Set up resell button if it exists
  const resellButton = document.querySelector('.cProd__buttons .resell');
  if(resellButton) {
    resellButton.setAttribute('href', '/pages/resell-submission?id='+idParam);
  }

  try {
    
    // Get data from Shopify using the SKU from attributes
    if(attributes.product && attributes.product.sku) {

      fetch('https://at-routes-for-map-d0602397f1c7.herokuapp.com/product-info?sku='+attributes.product.sku, {
        method: 'GET',
          headers: {
              'ngrok-skip-browser-warning': 'true'
          }
      })
      .then(response => response.json())
      .then(info => {
        const shopifyData = JSON.parse(info.body)

        if(shopifyData.image) {
          const imageElement = document.querySelector('.cProd__image-holder img');
          if(imageElement) {
            imageElement.setAttribute('src', shopifyData.image);
          }
        }

        if(shopifyData.description) {
          const descElement = document.querySelector('.cProd__info-descr');
          if(descElement) {
            descElement.innerHTML = shopifyData.description;
          }
        }

        if(shopifyData.title) {
          const titleElement = document.querySelector('.cProd__info-title');
          if(titleElement) {
            titleElement.innerHTML = shopifyData.title;
          }
        }

        if(shopifyData.url) {
          const repurchaseButton = document.querySelector('.cProd__buttons .repurchase');
          if(repurchaseButton) {
            repurchaseButton.setAttribute('href', shopifyData.url);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching product info:', error);
      });

     }

     // Render primary article sections from Aura data
     if(attributes.primaryArticle && attributes.primaryArticle.copySection4A) {
       renderArticles(attributes.primaryArticle.copySection4A)
     }

     if(attributes.primaryArticle && attributes.primaryArticle.copySection4B) {
       renderArticles(attributes.primaryArticle.copySection4B)
     } 

     if(attributes.primaryArticle && attributes.primaryArticle.copySection4C) {
       renderArticles(attributes.primaryArticle.copySection4C)
     } 

     if(attributes.primaryArticle && attributes.primaryArticle.copySection4D) {
       renderArticles(attributes.primaryArticle.copySection4D)
     }
     
     if(attributes.primaryArticle && attributes.primaryArticle.copySection4E) {
       renderArticles(attributes.primaryArticle.copySection4E)
     } 

     // Render factory sections from Aura data
     if(attributes.factory && attributes.factory.copySection4F) {
       renderArticles(attributes.factory.copySection4F)
     } 

     if(attributes.factory && attributes.factory.copySection4G) {
       renderArticles(attributes.factory.copySection4G)
     } 

     // Render who made section
     if(attributes.factory && attributes.factory.whoMade) {
       const whoMadeElement = document.getElementById('who-made');
       if(whoMadeElement) {
         whoMadeElement.innerHTML = '<p>'+attributes.factory.whoMade+'</p>' + '<p>'+attributes.factory.wimStat1+ '</p>';
       }
     }

     // Render animal welfare section
     if(attributes.primaryArticle && attributes.primaryArticle.welfareAnimal) {
       const animalElement = document.getElementById('animal');
       if(animalElement) {
         animalElement.innerHTML = '<p>'+attributes.primaryArticle.welfareAnimal+'</p>' + '<p>'+attributes.primaryArticle.wimStat2+ '</p>';
       }
     }

     // Render environmental welfare section - using wimStat3 since welfareEnvironmental is not in the data
     if(attributes.primaryArticle && attributes.primaryArticle.wimStat3) {
       const environmElement = document.getElementById('environm');
       if(environmElement) {
         environmElement.innerHTML = '<p>'+attributes.primaryArticle.wimStat3+'</p>';
       }
     }

     // Add title and description from the main response if not available from Shopify
     const titleElement = document.querySelector('.cProd__info-title');
     if(apiData.title && titleElement && !titleElement.innerHTML) {
       titleElement.innerHTML = apiData.title;
     }

     const descElement = document.querySelector('.cProd__info-descr');
     if(apiData.description && descElement && !descElement.innerHTML) {
       descElement.innerHTML = apiData.description;
     }

     // Show main content immediately - don't wait for map
     const spinnerElement = document.querySelector('.loading-overlay__spinner');
     if(spinnerElement) {
       spinnerElement.classList.add('hidden');
     }
     const cProdElement = document.querySelector('.cProd');
     if(cProdElement) {
       cProdElement.style.display = 'block';
     }

     // Start map rendering in background (async)
     renderMapAsync(attributes);


    
  } catch (err) {
  
    console.log('error'); // output to netlify function log
    console.log(err); // output to netlify function log
  
  }

} else {
  
  const spinnerElement = document.querySelector('.loading-overlay__spinner');
  if(spinnerElement) {
    spinnerElement.classList.add('hidden');
  }

  const cProdElement = document.querySelector('.cProd');
  if(cProdElement) {
    cProdElement.style.display = 'block';
  }
}

}

function renderArticles(data) {
  const provenItemValues = document.querySelectorAll('.cProd__proven-item-value');
  let num = provenItemValues.length + 1;

  const provenanceDiv = document.querySelector('#provenance > div');
  if(provenanceDiv) {
    const newItem = document.createElement('div');
    newItem.className = 'cProd__proven-item';
    newItem.innerHTML = `
      <div class="cProd__proven-item-number">${num}</div>
      <div class="cProd__proven-item-value">${data}</div>
    `;
    provenanceDiv.appendChild(newItem);
  }
}

// Async map rendering function - runs in background
async function renderMapAsync(attributes) {
  try {
    // Add loading indicator for map
    const googleMapElement = document.getElementById('googleMap');
    if(googleMapElement) {
      googleMapElement.innerHTML = '<div class="map-loading">Loading map...</div>';
    }

    // Map functionality using Aura data
    const createCoords = async (address, key) => {
      const geocoder = new google.maps.Geocoder();  

      try {
        
        // Check if markerInfo exists for this key, if not provide fallback
        let markerConfig;
        if (markerInfo && markerInfo[key]) {
          markerConfig = markerInfo[key];

        } else {
          // Generate fallback config based on key name
          const fallbackLabel = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).replace(/Location$/, '');
          const fallbackColor = '#808080'; // Default gray color
          markerConfig = {
            label: fallbackLabel,
            color: fallbackColor
          };
        }
        
        const coords = await geocoder.geocode({address:address});

        const lat = coords?.results[0]?.geometry?.location.lat() || null
        const lng = coords?.results[0]?.geometry?.location.lng() || null


        const markerData = {
          name: address,
          color: markerConfig.color,
          label: markerConfig.label,
          position: {
            lat,
            lng,
          },
        }
        return markerData
      } catch (err) {
        console.error('Geocoding error for', address, ':', err);
        return false
      }
    }

    const getStateLocation = async (filteredLocations) => {
      const combinedLocations = Object.entries(filteredLocations)
        .filter((l) => !!l[1])
        .map((location) => createCoords(location[1], location[0]))

      const locationsData = await Promise.allSettled(combinedLocations)
      const locations = locationsData.filter((l) => !!l).filter((l) => !!l.value)
      console.log(locations)

      return locations;
    }

    // Build locations from Aura data
    let customFieldLocations = {}
    
    // Add factory location if available
    if(attributes.factory && attributes.factory.address) {
      const factoryAddress = attributes.factory.address;
      customFieldLocations.factoryLocation = `${factoryAddress.city}, ${factoryAddress.country}`;
    }

    // Add distribution center location if available
    if(attributes.dc && attributes.dc['address.city'] && attributes.dc['address.country']) {
      customFieldLocations.dcLocation = `${attributes.dc['address.city']}, ${attributes.dc['address.country']}`;
    }

    // Add material manufacturer location if available
    if(attributes.primaryArticle && attributes.primaryArticle.materialMfgLocation) {
      customFieldLocations.materialMfgLocation = attributes.primaryArticle.materialMfgLocation;
    }

    // Add material spinner location if available
    if(attributes.primaryArticle && attributes.primaryArticle.materialSpinnerLocation) {
      customFieldLocations.materialSpinnerLocation = attributes.primaryArticle.materialSpinnerLocation;
    }

    // Add component A source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentASourceLocation) {
      customFieldLocations.componentASourceLocation = attributes.primaryArticle.componentASourceLocation;

    }

    // Add component B source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentBSourceLocation) {
      customFieldLocations.componentBSourceLocation = attributes.primaryArticle.componentBSourceLocation;
    }

    // Add component C source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentCSourceLocation) {
      customFieldLocations.componentCSourceLocation = attributes.primaryArticle.componentCSourceLocation;
    }

    // Add any other location data from attributes if available
    // You can add more location mappings here based on your data structure


    let markers = await getStateLocation(customFieldLocations)

    var options = {
      zoom:2,
      center:{ lat: 37.09024,
              lng: -95.712891},
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,        
      styles
    }

    var map = new google.maps.Map(document.getElementById('googleMap'),options);

    for(let marker of markers) {
      const markerImage = {
        fillOpacity: 1,
        path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
        fillColor: marker.value.color,
        strokeWeight: 1,
        strokeColor: 'black',
        scale: 0.1,
      }

      new google.maps.Marker({
        position:{
            lat: marker.value.position.lat,
            lng: marker.value.position.lng,
        },
        map: map,
        icon: markerImage
      });

      let markerInfo = `<svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="6"
                cy="6.70312"
                r="5.75"
                fill="white"
                stroke="black"
                strokeWidth="0.5"
              />
              <circle cx="6" cy="6.70312" r="4" fill=`+marker.value.color+` />
            </svg> <span>`+marker.value.label+`</span>`

      const mapMarkersElement = document.querySelector('.cProd__map-markers');
      if(mapMarkersElement) {
        const markerDiv = document.createElement('div');
        markerDiv.className = 'cProd__map-markers-item';
        markerDiv.innerHTML = markerInfo;
        mapMarkersElement.appendChild(markerDiv);
      }

    }

    const bounds = new google.maps.LatLngBounds()
   
    markers.map((item) => {
      bounds.extend(item.value.position)
      return item.id
    })

    map.fitBounds(bounds)

    console.log('Map rendering completed');

  } catch (err) {
    console.error('Map rendering error:', err);
    // Show error message in map container
    const googleMapElement = document.getElementById('googleMap');
    if(googleMapElement) {
      googleMapElement.innerHTML = '<div class="map-error">Map could not be loaded</div>';
    }
  }
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function(){
  const anchorSelector = 'a[href^="#"]';
  const anchorElements = document.querySelectorAll(anchorSelector);

  anchorElements.forEach(function(anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const destination = document.querySelector(targetId);
        
        if (destination) {
          const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position-desktop');
          const scrollPosition = destination.offsetTop - parseFloat(headerHeight);

          // Smooth scroll animation using vanilla JavaScript
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
    });
  });

  // Initialize claim ownership functionality
  initializeClaimOwnership();
});

/***************************************************************
 * Connected Products Page - Ownership Claim Logic
 * Author: David / Linea Codice
 ***************************************************************/

console.log("[AT] Claim ownership module loaded");

/* ---------------------------
   Extract uniqueHash from URL
----------------------------*/
function getUniqueHashFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get("id");
}

/* ---------------------------
   Shopify customer login check
----------------------------*/
function getCurrentCustomer() {
  return window.__AT_CUSTOMER || null;
}

function isLoggedIn() {
  const customer = getCurrentCustomer();
  console.log("[AT] Current customer:", customer);
  return !!(customer && customer.email);
}

/* ---------------------------
   CLAIM OWNERSHIP request
----------------------------*/
let isClaimInProgress = false;

async function claimOwnership() {
  // Prevent multiple simultaneous claims
  if (isClaimInProgress) {
    console.log("[AT] Claim already in progress, ignoring click");
    return;
  }

  const uniqueHash = getUniqueHashFromUrl();
  if (!uniqueHash) {
    console.error("[AT] No unique hash in URL");
    updateClaimButtonText("Error: No product ID found in URL");
    return;
  }

  const customer = getCurrentCustomer();
  if (!customer || !customer.email) {
    console.error("[AT] User not logged in");
    updateClaimButtonText("Error: User not logged in");
    return;
  }

  const payload = {
    uniqueHash: uniqueHash,
    email: customer.email,
    state: "OWNED"
  };

  console.log("[AT] Claiming ownership with payload:", payload);

  const btn = document.getElementById("claim-ownership-btn");
  
  // Mark claim as in progress and disable link
  isClaimInProgress = true;
  if (btn) {
    btn.style.pointerEvents = "none";
    btn.style.opacity = "0.6";
    btn.style.color = "#0c61eb";
  }

  updateClaimButtonText("Aura Blockchain Registration in Progress...");

  try {
    // Use the same base URL as the existing code
    const res = await fetch(`${NEW_ROUTE_BASE}/claim`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
          'ngrok-skip-browser-warning': 'true'
      },

      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: "Unknown error" }));
      throw new Error(errorData.error || `Claim request failed: ${res.status}`);
    }

    const result = await res.json();
    console.log("[AT] Claim success:", result);

    // Keep button disabled permanently after success
    if (btn) {
      btn.style.opacity = "0.5";
      btn.style.color = "#0a0a0a";
      btn.style.cursor = "not-allowed";
    }
    updateClaimButtonText("Ownership claimed successfully !");

  } catch (err) {
    console.error("[AT] Error during claim", err);
    
    // Re-enable button on error
    isClaimInProgress = false;
    if (btn) {
      btn.style.pointerEvents = "auto";
      btn.style.opacity = "1";
      btn.style.color = "#0a0a0a";
    }
    updateClaimButtonText(`Error: ${err.message}`);
  }
}

/* ---------------------------
   Update claim button text
----------------------------*/
function updateClaimButtonText(message) {
  const btn2 = document.getElementById("claim-ownership-btn");
  if (!btn2) return;

  const h3 = btn2.querySelector('h3');
  if (h3) {
    const svg = h3.querySelector('svg');
    const svgHTML = svg ? svg.outerHTML : '';
    h3.innerHTML = message + ' ' + svgHTML;
  }
}

/* ---------------------------
   Handle Claim Button Click
----------------------------*/
function setupClaimButton() {
  const btn = document.getElementById("claim-ownership-btn");
  if (!btn) {
    console.log("[AT] Claim button not found");
    return;
  }

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    if (!isLoggedIn()) {
      console.log("[AT] User not logged in, redirecting to login");

      // Preserve intent (we want to claim after login)
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('claim', 'true');
      const returnUrl = currentUrl.pathname + currentUrl.search;

      // Store intent for register flow
      localStorage.setItem("AT_claim_intent", returnUrl);

      // CHECK: Are you using Classic Accounts (email/pass) or New Accounts (code)?
      
      // OPTION A: Classic Customer Accounts (Legacy)
      // Use this if you switched to "Classic customer accounts" in Shopify Admin > Settings > Customer accounts
      window.location.href = `/account/login?return_url=${encodeURIComponent(returnUrl)}`;

      // OPTION B: New Customer Accounts (6-digit code)
      // Use this if you are using the new system
      // window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;
      
      return;
    }

    // Already logged in → immediate claim
    console.log("[AT] User logged in, claiming ownership");
    claimOwnership();
  });
}

/* ---------------------------
   Auto claim after login
----------------------------*/
function initializeClaimOwnership() {
  setupClaimButton();

  // If user returns from login with #claim
  const params = new URLSearchParams(location.search);
  if (params.has("claim") && isLoggedIn()) {
    console.log("[AT] Auto-claim triggered after login");
    
    // Clean URL
    params.delete("claim");
    const cleanUrl = window.location.pathname + "?" + params.toString();
    window.history.replaceState({}, "", cleanUrl);

    // Small delay to ensure page is fully loaded
    setTimeout(() => {
      claimOwnership();
    }, 1500);
  }
}

/* ---------------------------
   Handle Claim Button State
----------------------------*/
async function handleClaimButtonState(status, productId, uniqueHash) {
  const btn = document.getElementById("claim-ownership-btn");
  if (!btn) return;

  // Case 1: Product is NOT claimed (CREATED)
  if (status === 'CREATED') {
    console.log("[AT] Product is unclaimed. Enabling claim button.");
    // Default behavior is already correct (button enabled)
    // Just ensure text is correct
    const h3 = btn.querySelector('h3');
    if(h3) h3.innerHTML = 'Register your ownership of this product ' + (h3.querySelector('svg')?.outerHTML || '');
    return;
  }

  // Case 2: Product is ALREADY claimed (OWNED)
  if (status === 'OWNED') {
    console.log("[AT] Product is already claimed.");
    
    // Disable button immediately
    btn.classList.add('disabled');
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';
    btn.removeAttribute('href');
    
    const h3 = btn.querySelector('h3');
    // Default message while checking
    if(h3) h3.innerHTML = 'Product already registered ' + (h3.querySelector('svg')?.outerHTML || '');
    
    // Hide "Sign-in required" text if present
    const subText = btn.querySelector('.cProd__buttons-holder_sub_text');
    if(subText) subText.style.display = 'none';

    // Check if current user is the owner
    if (isLoggedIn()) {
      const customer = getCurrentCustomer();
      console.log("[AT] Checking if current user is the owner...");
      
      try {
        const isOwner = await checkOwnership(customer.email, uniqueHash, productId);
        
        if (isOwner) {
          if(h3) h3.innerHTML = 'You own this product ' + (h3.querySelector('svg')?.outerHTML || '');
          console.log("[AT] User IS the owner.");
        } else {
          if(h3) h3.innerHTML = 'This product is owned by an AnotherTomorrow customer ' + (h3.querySelector('svg')?.outerHTML || '');
          console.log("[AT] User is NOT the owner.");
        }
      } catch (err) {
        console.error("[AT] Error checking ownership:", err);
      }
    } else {
      // Not logged in, but product is owned
      if(h3) h3.innerHTML = 'This product is owned by an AnotherTomorrow customer ' + (h3.querySelector('svg')?.outerHTML || '');
    }
  }
}

/* ---------------------------
   Check Ownership API Call
----------------------------*/
async function checkOwnership(email, uniqueHash, productId) {
  try {
    const res = await fetch(`${NEW_ROUTE_BASE}/check-ownership`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        'ngrok-skip-browser-warning': 'true'
      },
      body: JSON.stringify({ email, uniqueHash, productId })
    });

    if (!res.ok) {
      throw new Error(`Ownership check failed: ${res.status}`);
    }

    const data = await res.json();
    return data.isOwner;
  } catch (err) {
    console.error("[AT] Check ownership error", err);
    return false;
  }
}